import { render, staticRenderFns } from "./virtual.vue?vue&type=template&id=20eb7a28&scoped=true"
import script from "./virtual.vue?vue&type=script&lang=ts"
export * from "./virtual.vue?vue&type=script&lang=ts"
import style0 from "./virtual.vue?vue&type=style&index=0&id=20eb7a28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eb7a28",
  null
  
)

export default component.exports